import React from 'react';
import useTagManager from '@/features/data-loader/hooks/useTagManager';
import useUserLocaleRedirect from '@/features/data-loader/hooks/useUserLocaleRedirect';
import useMarketRedirect from '@/features/data-loader/hooks/useMarketRedirect';
import useWordpressLoader from '@/features/data-loader/hooks/useWordpressLoader';
import useGamesLoader from '@/features/data-loader/hooks/useGamesLoader';
import useKycLoader from '@/features/data-loader/hooks/useKycLoader';
import useSentry from '@/features/data-loader/hooks/useSentry';
import useAmlVerificationStatusLoader from '@/features/data-loader/hooks/useAmlVerificationStatusLoader';
import useIpDataLoader from '@/features/data-loader/hooks/useIpDataLoader';
import useDetailsReverification from '@/features/data-loader/hooks/useDetailsReverification';
import useBtagLogic from '@/features/data-loader/hooks/useBtagLogic';
import useSearchParams from '@/features/data-loader/hooks/useSearchParams';
import useWrapperPlatformClass from '@/features/data-loader/hooks/useWrapperPlatformClass';
import { useWalletLoader } from '@/features/data-loader/hooks/useWalletLoader';
import useInitialAuthFlow from '@/features/data-loader/hooks/useInitialAuthFlow';
import { useFaqLoader } from '@/hooks/useFaqLoader';
import { usePromotionsLoader } from '@/features/data-loader/hooks/usePromotionsLoader';
import useCmsLoader from '@/features/data-loader/hooks/useCmsLoader';
import { useWelcomeTextsLoader } from '@/features/data-loader/hooks/useWelcomeTextsLoader';
import { useOntarioCheck } from '@/features/data-loader/hooks/useOntarioCheck';
import { useRegionGate } from '@/features/data-loader/hooks/useRegionGate';
import { useHeaderBannersLoader } from '@/hooks/useHeaderBannersLoader';
import { useHeroBackgroundsLoader } from '@/features/data-loader/hooks/useHeroBackgroundsLoader';
import { useBonusesLoader } from '@/features/data-loader/hooks/useBonusesLoader';

export function DataLoader({ children }: { children: React.ReactChildren }): JSX.Element {
  useBonusesLoader();
  useTagManager();
  useUserLocaleRedirect();
  useMarketRedirect();
  useWordpressLoader();
  useGamesLoader();
  useKycLoader();
  useSentry();
  useAmlVerificationStatusLoader();
  useIpDataLoader();
  useDetailsReverification();
  useBtagLogic();
  useSearchParams();
  useWrapperPlatformClass();
  useInitialAuthFlow();
  usePromotionsLoader();
  useCmsLoader();
  useFaqLoader();
  useWelcomeTextsLoader();
  useWalletLoader();
  useOntarioCheck();
  useRegionGate();
  useHeaderBannersLoader();
  useHeroBackgroundsLoader();

  return <>{children}</>;
}
